// extracted by mini-css-extract-plugin
export default {"zr-checkbox":"Checkbox_zr-checkbox__KaS+1","checkmark":"Checkbox_checkmark__gVt5U","zr-checkbox-tree":"Checkbox_zr-checkbox-tree__l-BZN","label-text":"Checkbox_label-text__FJNQl"};